export default function ReadyToCreateList({
  a: assessment,
  handleCreatePDF,
  isCreating = false,
}) {
  return (
    <article className="readyToSendToLeaderDiv">
      <p>
        <strong>User ID:</strong>{" "}
        {assessment.user_id}
      </p>

      <p>
        <strong>Test ID:</strong>{" "}
        {assessment.test_id}
      </p>

      <p>
        <strong>Moderator ID:</strong>{" "}
        {assessment.moderator_id ??
          "No moderator recorded"}
      </p>

      <p>
        <strong>Ready for Coordinator?</strong>{" "}
        {assessment.ready_for_coordinator
          ? "Yes"
          : "No"}
      </p>

      <p>
        <strong>Ready to Create PDF?</strong>{" "}
        {assessment.ready_to_send_to_leader
          ? "Yes"
          : "No"}
      </p>

      <p>
        <strong>Sent?</strong>{" "}
        {assessment.sent ? "Yes" : "No"}
      </p>

      <p>
        <strong>Knowledge Score:</strong>{" "}
        {assessment.knowledge_score ?? 0}
      </p>

      <p>
        <strong>Current Identification Score:</strong>{" "}
        {assessment.identify_score ?? 0}
      </p>

      <button
        type="button"
        className="submitUserUpdateButton"
        onClick={() =>
          handleCreatePDF(
            assessment.user_id,
            assessment.test_id
          )
        }
        disabled={isCreating}
      >
        {isCreating
          ? "Opening..."
          : "Create PDF"}
      </button>
    </article>
  );
}